import { memo } from "react";
import {
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg viewBox="0 0 256 256" {...otherProps} height={size} width={size}>
    <_Rect width="256" height="256" fill="none" />
    <_Path
      d="M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="24"
    />
  </_Svg>;
};
Icon.displayName = "HouseBold";
const HouseBold = memo(themed(Icon));
export {
  HouseBold
};
//# sourceMappingURL=house-bold.js.map
